import { AxiosResponse } from 'axios'
import { Action } from 'redux'
import {
  call,
  CallEffect,
  ForkEffect,
  put,
  PutEffect,
  takeLatest,
} from 'redux-saga/effects'
import { CREATE_CHECKPOINTS } from '../../actions/createCheckpoints'
import {
  createCheckpoint,
  createOldCheckpoint,
  OldCheckpointTab,
  SubTab,
} from '../../actions/createCheckpoints/createCheckpointRequests'
import getStatus from '../../actions/getStatus'
import {
  getMostRecentId,
  getMostRecentDateString,
} from '../../helpers/getMostRecent'

type Yield = CallEffect<AxiosResponse> | PutEffect
type Return = void
type Next = undefined

export interface Checkpointable {
  checkpointableDate: Date
  createdAt?: Date
  entityType?: 'phase_item' | 'assignment'
  id: string | number
}

export type Payload = {
  items: Checkpointable[]
  subTab?: SubTab
  tab: OldCheckpointTab
}

export interface ActionWithPayload extends Action {
  payload: Payload
}

export function* createCheckpointsAndGetStatus(
  action: ActionWithPayload
): Generator<Yield, Return, Next> {
  try {
    const tab = action.payload.tab

    if (tab === 'Notification' || tab === 'Download') {
      const latestId = getMostRecentId(
        action.payload.items.map((item) => ({
          ...item,
          checkpointableDate: item.createdAt || new Date(),
        }))
      )

      yield call(createOldCheckpoint, {
        id: latestId,
        tab,
      })
    } else {
      const contentTasks = action.payload.items.filter(
        (item) => item.entityType === 'phase_item'
      )
      const momentTasks = action.payload.items.filter(
        (item) => item.entityType === 'assignment'
      )

      if (contentTasks.length > 0) {
        const latestId = getMostRecentId(contentTasks)

        yield call(createOldCheckpoint, {
          id: latestId,
          subTab: action.payload.subTab,
          tab,
        })
      }
      if (momentTasks.length > 0 && action.payload.subTab !== undefined) {
        const latestDateString = getMostRecentDateString(momentTasks)

        yield call(createCheckpoint, {
          last_viewed_at: latestDateString,
          subTab: action.payload.subTab,
          tab,
        })
      }
    }

    yield put(getStatus())
  } catch (error) {
    console.error(error)
  }
}

export function* createCheckpoints(): Generator<ForkEffect, void, void> {
  yield takeLatest(CREATE_CHECKPOINTS, createCheckpointsAndGetStatus)
}

export default [createCheckpoints]
